<div class="appeals-packet-container">
  <p-panel [toggleable]="false" [collapsed]="false" styleClass="appeals-packet-panel">
    <ng-template pTemplate="header">
      <div class="w-full">
        <div class="flex items-center gap-2 pb-2">
          <i class="pi pi-chevron-down text-xs text-gray-600 chevron-icon"></i>
          <i class="pi pi-exclamation-circle"></i>
          <span class="text-gray-700 font-semibold text-sm leading-5 align-middle">A&G Appeals Packet</span>
        </div>
        <div class="ml-5 border-t border-gray-300"></div>
        <div class="ml-5 flex align-items-center gap-2 pt-2 mt-3">
          <span class="packet-info-text">The appeals packet is partially pre-filled. Review the values below and make any necessary adjustments.</span>
        </div>
      </div>
    </ng-template>

    <form [formGroup]="appealsForm">
      <div class="space-y-4">
        <!-- Packet Type Selection -->
        <div class="flex items-center gap-4">
          <label for="packetType" class="text-sm whitespace-nowrap field-required self-center mb-0">Select Packet Type:
          </label>
          <p-select
            id="packetType"
            formControlName="packetType"
            [options]="packetTypeOptions"
            placeholder="Select"
            styleClass="w-64"
            appendTo="body"
          ></p-select>
        </div>
        
        @if (selectedPacketType) {
          <div class="w-full border-t border-gray-300"></div>
        }

        <!-- Auth/Appeal Details -->
        @if (selectedPacketType) {
          <div>
            <div class="field">
              <label class="block mb-2 text-sm">Auth/Appeal Details:</label>
            </div>
            <button
              pButton
              type="button"
              label="View Details"
              icon="pi pi-external-link"
              severity="secondary"
              [outlined]="true"
              (click)="showAuthAppealDetailsModal()"
            ></button>
          </div>

          <!-- Action Type -->
          <div>
            <div class="field">
              <label class="block mb-2 text-sm field-required">Action Type:
              </label>
            </div>
            <div class="space-y-2">
              <div class="flex items-center">
                <p-checkbox
                  formControlName="actionTypes"
                  value="End all covered services (NOMNC/DENC)"
                  inputId="action1"
                  [binary]="false"
                />
                <label for="action1" class="ml-2 text-sm">End all covered services (NOMNC/DENC)</label>
              </div>
              <div class="flex items-center">
                <p-checkbox
                  formControlName="actionTypes"
                  value="Reduce covered services"
                  inputId="action2"
                  [binary]="false"
                />
                <label for="action2" class="ml-2 text-sm">Reduce covered services</label>
              </div>
              <div class="flex items-center">
                <p-checkbox
                  formControlName="actionTypes"
                  value="Deny admission to Post-Acute care"
                  inputId="action3"
                  [binary]="false"
                />
                <label for="action3" class="ml-2 text-sm">Deny admission to Post-Acute care</label>
              </div>
              <div class="flex items-center">
                <p-checkbox
                  formControlName="actionTypes"
                  value="Other"
                  inputId="action4"
                  [binary]="false"
                />
                <label for="action4" class="ml-2 text-sm">Other</label>
              </div>
              @if (appealsForm.get('actionTypes')?.value?.includes('Other')) {
                <div class="mt-2">
                  <div class="field">
                    <label for="actionTypeOther" class="block mb-2 text-sm field-required">Other - Details:
                    </label>
                  </div>
                  <textarea
                    pTextarea
                    id="actionTypeOther"
                    formControlName="actionTypeOther"
                    rows="3"
                    class="w-full"
                    maxlength="5000"
                  ></textarea>
                  <span class="block text-right">{{ appealsForm?.get('actionTypeOther')?.value ? appealsForm?.get('actionTypeOther')?.value.length : 0 }} / 5000</span>
                </div>
              }
            </div>
          </div>

          <!-- Appeal Type -->
          <div>
            <div class="field">
              <label class="block mb-2 text-sm field-required">Appeal Type:
              </label>
            </div>
            <div class="space-y-2">
              <div class="flex items-center">
                <p-radiobutton
                  formControlName="appealType"
                  name="appealType"
                  value="Expedited"
                  inputId="appeal1"
                />
                <label for="appeal1" class="ml-2 text-sm">Expedited</label>
              </div>
              <div class="flex items-center">
                <p-radiobutton
                  formControlName="appealType"
                  name="appealType"
                  value="Standard"
                  inputId="appeal2"
                />
                <label for="appeal2" class="ml-2 text-sm">Standard</label>
              </div>
            </div>
          </div>

           @if (isQIOAppeal) {
            <!-- Signed NOMNC Returned -->
            <div>
              <div class="field">
                <label class="block mb-2 text-sm field-required">Signed NOMNC returned to Carelon?
                </label>
              </div>
              <div class="flex flex-col gap-2">
                    <div class="flex items-center">
                      <p-radiobutton
                        formControlName="signedNomnc"
                        name="signedNomnc"
                        value="Yes"
                        inputId="signedNomncYes"
                      ></p-radiobutton>
                      <label for="signedNomncYes" class="ml-2">Yes</label>
                    </div>
                    <div class="flex items-center">
                      <p-radiobutton
                        formControlName="signedNomnc"
                        name="signedNomnc"
                        value="No"
                        inputId="signedNomncNo"
                      ></p-radiobutton>
                      <label for="signedNomncNo" class="ml-2">No</label>
                    </div>
                </div>
            </div>

            <!-- Additional Notes on NOMNC Delivery -->
            @if (appealsForm.get('signedNomnc')?.value === 'No') {
              <div class="max-w-md">
                <div class="field">
                  <label for="additionalNotesOnNomnc" class="block mb-2 text-sm field-required">Additional notes on NOMNC delivery:
                  </label>
                </div>
                <p-select
                  id="additionalNotesOnNomnc"
                    formControlName="additionalNotesOnNomnc"
                    [options]="additionalNotesNomncOptions"
                    placeholder="Select"
                  styleClass="w-full"
                ></p-select>
              </div>
              @if (appealsForm.get('additionalNotesOnNomnc')?.value === 'Other') {
                <div class="mt-2">
                  <div class="field">
                    <label for="additionalNotesOnNomncOther" class="block mb-2 text-sm field-required">Other - Details:
                    </label>
                  </div>
                  <textarea
                    pTextarea
                    id="additionalNotesOnNomncOther"
                    formControlName="additionalNotesOnNomncOther"
                    rows="3"
                    class="w-full"
                    maxlength="5000"
                  ></textarea>
                  <span class="block text-right">{{ appealsForm?.get('additionalNotesOnNomncOther')?.value ? appealsForm?.get('additionalNotesOnNomncOther')?.value.length : 0 }} / 5000</span>
                </div>
              }
            }
            
            @if (appealsForm.get('signedNomnc')?.value !== null && appealsForm.get('signedNomnc')?.value === 'No') {
              <div>
                <div class="field">
                  <label class="block mb-2 text-sm field-required">Carelon follow‑up/outreach documented?
                  </label>
                </div>
                <div class="flex flex-col gap-2">
                      <div class="flex items-center">
                        <p-radiobutton
                          formControlName="carelonFollowUpDocumented"
                          name="carelonFollowUpDocumented"
                          [value]="true"
                          inputId="carelonFollowUpYes"
                        ></p-radiobutton>
                        <label for="carelonFollowUpYes" class="ml-2">Yes</label>
                      </div>
                      <div class="flex items-center">
                        <p-radiobutton
                          formControlName="carelonFollowUpDocumented"
                          name="carelonFollowUpDocumented"
                          [value]="false"
                          inputId="carelonFollowUpNo"
                        ></p-radiobutton>
                        <label for="carelonFollowUpNo" class="ml-2">No</label>
                      </div>
                  </div>
              </div>

              <!-- Carelon Follow-up Date -->
              @if (appealsForm.get('carelonFollowUpDocumented')?.value === true) {
              <div class="max-w-md">
                <div class="field">
                  <label for="carelonFollowUpDate" class="block mb-2 text-sm field-required">Follow-up/Outreach Date:
                  </label>
                </div>
                <p-datepicker
                    id="carelonFollowUpDate"
                    formControlName="carelonFollowUpDate"
                    [showIcon]="true"
                    [showButtonBar]="true"
                    [readonlyInput]="true"
                  styleClass="w-35"
                ></p-datepicker>
              </div>
              }
            }
          }

          <!-- Primary Health Plan Contact -->
          <div class="max-w-md">
            <div class="field">
              <label for="primaryHealthPlanContact" class="block mb-2 text-sm">
                Primary Health Plan Contact:
              </label>
            </div>
            <input
              pInputText
              id="primaryHealthPlanContact"
              formControlName="primaryHealthPlanContact"
              class="w-full"
              maxlength="5000"
            />
          </div>

          <!-- Exhibits Section -->
          <div class="max-w-md">
            <div class="field">
              <label for="exhibits" class="block mb-2 text-sm field-required">Exhibits:
              </label>
            </div>
            <p-multiselect
                id="exhibits"
                formControlName="exhibits"
                [options]="exhibitOptions"
                placeholder="Select"
                styleClass="w-full"
                [showToggleAll]="true"
                [filter]="false"
            ></p-multiselect>
            <p class="info-message">
              <i class="pi pi-info-circle mr-2"></i>
              Selected exhibits will be attached to the packet.
            </p>
          </div>
          
          @if (appealsForm.get('exhibits')?.value?.includes('Case management notes/referrals')) {
            <div class="col-span-12">
              <div class="field">
                <label for="caseManagementNotesDetails" class="field-required">
                  Case Management Notes/Referrals - Details:
                  </label>
                  <textarea
                    pTextarea
                    id="caseManagementNotesDetails"
                    formControlName="caseManagementNotesDetails"
                    rows="4"
                    class="w-full"
                    maxlength="5000"
                  ></textarea>
                  <span class="block text-right">{{ appealsForm?.get('caseManagementNotesDetails')?.value ? appealsForm?.get('caseManagementNotesDetails')?.value.length : 0 }} / 5000</span>
                </div>
              </div>
            }

            
          <!-- Documents Selection -->
          <div class="col-span-12 mt-2">
            <p-divider styleClass="!mb-0"></p-divider>
            <div class="field">
              <label class="block text-sm mt-1">Select Documents:</label>
            </div>
            <!-- Documents List Component -->
            <mnc-documents-documents-list
              [authorizationByProductId]="authorizationByProductId"
              [authorizationNumber]="authorizationNumber"
              [documentFilter]="documentFilter"
              [filterable]="true"
              [isDocumentsTab]="false"
              [isExternal]="isExternal"
              [selectable]="true"
              [showChecked]="false"
              [showDownloadButton]="false"
              [showClearFiltersButton]="false"
              [tenantId]="tenantId"
              [tenantName]="tenantName"
              (selectedDocuments)="onDocumentSelectionChange($event)"
            >
            </mnc-documents-documents-list>
            
            <!-- Footer Info -->
            <div class="mt-3 space-y-2">
              <div class="text-sm text-gray-600">{{ maxFileSizeLabel }}</div>
              <div class="info-message">
                <i class="pi pi-info-circle"></i>
                <span>Selected documents will be attached to the packet.</span>
              </div>
            </div>
          </div>
 
          <!-- Last Approved Day -->
          <div class="max-w-md">
            <div class="field">
              <label for="lastApprovedDay" class="block mb-2 text-sm field-required">Last Approved Day:
              </label>
            </div>
            <p-datepicker
              id="lastApprovedDay"
              formControlName="lastApprovedDay"
              [showIcon]="true"
              [showButtonBar]="true"
              [readonlyInput]="true"
              styleClass="w-35"
              placeholder = 'mm/dd/yyyy'
            ></p-datepicker>
          </div>
                    <!-- Case Snapshot -->
          <div class="col-span-12">
            <div class="field">
              <label for="caseSnapshot" class="field-required">Case Snapshot:</label>
              <p class="text-sm text-gray-600 mb-2">{{caseSnapshotFormatMessage}}</p>
              <textarea
                pTextarea
                id="caseSnapshot"
                formControlName="caseSnapshot"
                rows="4"
                class="w-full"
                maxlength="5000"
              ></textarea>
              <div class="flex justify-between items-center mt-1">
                <p class="text-sm text-gray-600">{{caseSnapshotContinuationMessage}}</p>
                <span class="text-right">{{ appealsForm?.get('caseSnapshot')?.value ? appealsForm?.get('caseSnapshot')?.value.length : 0 }} / 5000</span>
              </div>
            </div>
          </div>

          <!-- Action Being Appealed -->
          <div class="col-span-12">
            <div class="field">
              <label class="field-required">Action being appealed:</label>
              <div class="flex flex-col gap-2 mt-2">
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="actionBeingAppealed"
                      value="Terminate ALL covered services"
                      inputId="actionAppealed1"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="actionAppealed1" class="ml-2" style="font-weight: normal;">Terminate ALL covered services</label>
                  </div>
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="actionBeingAppealed"
                      value="Reduce/partial terminate"
                      inputId="actionAppealed2"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="actionAppealed2" class="ml-2" style="font-weight: normal;">Reduce/partial terminate</label>
                  </div>
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="actionBeingAppealed"
                      value="Deny admission"
                      inputId="actionAppealed3"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="actionAppealed3" class="ml-2" style="font-weight: normal;">Deny Admission</label>
                  </div>
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="actionBeingAppealed"
                      value="Other"
                      inputId="actionAppealed4"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="actionAppealed4" class="ml-2" style="font-weight: normal;">Other</label>
                  </div>
                @if (appealsForm.get('actionBeingAppealed')?.value?.includes('Other')) {
                  <div class="mt-2">
                    <div class="field">
                      <label for="actionBeingAppealedOther" class="block mb-2 text-sm field-required">Other - Details:
                      </label>
                    </div>
                    <textarea
                      pTextarea
                      id="actionBeingAppealedOther"
                      formControlName="actionBeingAppealedOther"
                      rows="3"
                      class="w-full"
                      maxlength="5000"
                    ></textarea>
                    <span class="block text-right">{{ appealsForm?.get('actionBeingAppealedOther')?.value ? appealsForm?.get('actionBeingAppealedOther')?.value.length : 0 }} / 5000</span>
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- Primary Denial Reasons -->
          <div class="col-span-12">
            <div class="field max-w-md">
              <label class="field-required">Primary denial reason(s):</label>
              <p-multiselect
                [options]="primaryDenialReasons"
                formControlName="primaryDenialReasons"
                placeholder="Select"
                [showClear]="true"
                styleClass="w-full"
                display="chip"
                [filter]="false"
              ></p-multiselect>
            </div>
          </div>

          <!-- Supporting Facts - Shows one for each selected denial reason -->
          @if (showSupportingFact && supportingFactsArray?.length > 0) {
            @for (factGroup of supportingFactsArray?.controls; track $index) {
              <div class="col-span-12">
                <div class="field">
                  <label class="field-required">
                    {{ factGroup.get('denialReason')?.value }} - Supporting Facts:
                  </label>
                  <textarea
                    pTextarea
                    [formControl]="factGroup.get('supportingFact')"
                    rows="5"
                    class="w-full"
                    maxlength="5000"
                  ></textarea>
                  <div class="flex justify-end items-center mt-1">
                    <span>{{ factGroup.get('supportingFact')?.value ? factGroup.get('supportingFact')?.value.length : 0 }} / 5000</span>
                  </div>
                </div>
              </div>
            }
          }

          <!-- Criteria Used -->
          <div class="col-span-12">
            <div class="field">
              <label class="field-required">Criteria used and specific requirement:</label>
              <div class="flex flex-col gap-2 mt-2">
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="criteriaUsed"
                      value="Medicare Benefit Policy Manual (MBPM), Chapter 8 – SNF Level of Care"
                      inputId="criteria1"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="criteria1" class="ml-2" style="font-weight: normal;">Medicare Benefit Policy Manual (MBPM), Chapter 8 – SNF Level of Care</label>
                  </div>
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="criteriaUsed"
                      value="Medicare Benefit Policy Manual (MBPM), Chapter 1 – IRF Level of Care"
                      inputId="criteria2"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="criteria2" class="ml-2" style="font-weight: normal;">Medicare Benefit Policy Manual (MBPM), Chapter 1 – IRF Level of Care</label>
                  </div>
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="criteriaUsed"
                      value="Milliman Care Guidelines (MCG), GRG-049"
                      inputId="criteria3"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="criteria3" class="ml-2" style="font-weight: normal;">Milliman Care Guidelines (MCG), GRG-049</label>
                  </div>
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="criteriaUsed"
                      value="Milliman Care Guidelines (MCG), GRG-050"
                      inputId="criteria4"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="criteria4" class="ml-2" style="font-weight: normal;">Milliman Care Guidelines (MCG), GRG-050</label>
                  </div>
                  <div class="flex items-center">
                    <p-checkbox
                      formControlName="criteriaUsed"
                      value="Other"
                      inputId="criteria5"
                      [binary]="false"
                    ></p-checkbox>
                    <label for="criteria5" class="ml-2" style="font-weight: normal;">Other</label>
                  </div>
                  @if (appealsForm.get('criteriaUsed')?.value?.includes('Other')) {
                    <div class="mt-2">
                      <div class="field">
                        <label for="criteriaUsedOther" class="block mb-2 text-sm field-required">Other - Details:
                        </label>
                      </div>
                      <textarea
                        pTextarea
                        id="criteriaUsedOther"
                        formControlName="criteriaUsedOther"
                        rows="3"
                        class="w-full"
                        maxlength="5000"
                      ></textarea>
                      <span class="block text-right">{{ appealsForm?.get('criteriaUsedOther')?.value ? appealsForm?.get('criteriaUsedOther')?.value.length : 0 }} / 5000</span>
                    </div>
                  }
                </div>
              </div>
            </div>

          <!-- Primary Rationale -->
          <div class="col-span-12">
            <div class="field">
              <label for="primaryRationale" class="field-required">Primary Rationale from Physician Review Note and P2P:
              </label>
              <textarea
                pTextarea
                id="primaryRationale"
                formControlName="primaryRationale"
                rows="4"
                class="w-full"
                maxlength="5000"
              ></textarea>
              <span class="block text-right">{{ appealsForm?.get('primaryRationale')?.value ? appealsForm?.get('primaryRationale')?.value.length : 0 }} / 5000</span>
            </div>
          </div>

          <!-- Primary Documents Reviewed -->
          <div class="col-span-12">
            <div class="field">
              <label class="field-required">Primary documents reviewed to support the medical necessity determination:
              </label>
              <div class="flex flex-col gap-2 mt-2">
                  <div class="flex items-center">
                    <p-radiobutton
                      formControlName="primaryDocumentReviewed"
                      name="primaryDocumentReviewed"
                      value="Clinical Review Note"
                      inputId="primaryDoc1"
                    ></p-radiobutton>
                    <label for="primaryDoc1" class="ml-2" style="font-weight: normal;">Clinical Review Note</label>
                  </div>
                  <div class="flex items-center">
                    <p-radiobutton
                      formControlName="primaryDocumentReviewed"
                      name="primaryDocumentReviewed"
                      value="Physician Review Note"
                      inputId="primaryDoc2"
                    ></p-radiobutton>
                    <label for="primaryDoc2" class="ml-2" style="font-weight: normal;">Physician Review Note</label>
                  </div>
                  <div class="flex items-center">
                    <p-radiobutton
                      formControlName="primaryDocumentReviewed"
                      name="primaryDocumentReviewed"
                      value="N/A"
                      inputId="primaryDoc3"
                    ></p-radiobutton>
                    <label for="primaryDoc3" class="ml-2" style="font-weight: normal;">N/A</label>
                  </div>
              </div>
              
              <label for="primaryDocumentsReviewedText" class="block mt-3 mb-2 text-sm field-required">
                Primary documents reviewed:
              </label>
              <textarea
                pTextarea
                id="primaryDocumentsReviewedText"
                formControlName="primaryDocumentsReviewedText"
                rows="4"
                class="w-full"
                maxlength="5000"
              ></textarea>
              <div class="flex justify-between items-center mt-1">
                <p class="info-message">
                  <i class="pi pi-info-circle"></i>
                  This field auto-populates from the 'Comments' field of the selected note.
                </p>
                <span class="text-right">{{ appealsForm?.get('primaryDocumentsReviewedText')?.value ? appealsForm?.get('primaryDocumentsReviewedText')?.value.length : 0 }} / 5000</span>
              </div>
              </div>
          </div>

          <!-- Transition of Care Coordination -->
          <!-- Carelon Coordination Actions -->
          <div class="col-span-12">
            <div class="field">
              <label class="field-required">Carelon coordination actions:</label>
              <div class="flex flex-col gap-2 mt-2">
                  @for (action of carelonCoordinationActionsOptions; track action; let idx = $index) {
                    <div>
                      <div class="flex items-center">
                        <p-checkbox
                          [value]="action"
                          [inputId]="'carelon' + idx"
                          [binary]="true"
                          [ngModel]="isCarelonCoordinationActionSelected(action)"
                          (onChange)="onCarelonCoordinationActionChange($event, action)"
                          [ngModelOptions]="{standalone: true}"
                        ></p-checkbox>
                        <label [for]="'carelon' + idx" class="ml-2" style="font-weight: normal;">{{ action }}</label>
                      </div>
                      
                      @if (isCarelonCoordinationActionSelected(action) && action !== 'No additional discharge planning detail was provided before final determination' && action !== 'Other') {
                        <div class="mt-2 ml-6">
                          <label class="field-required">Date:  </label>
                          @for (control of carelonCoordinationActionsArray?.controls; track control; let i = $index) {
                            @if (control.get('action')?.value === action) {
                              <p-datepicker
                                [formControl]="control.get('actionDate')"
                                [showIcon]="true"
                                [showButtonBar]="true"
                                [readonlyInput]="true"
                                styleClass="w-35"
                              ></p-datepicker>
                            }
                          }
                        </div>
                      }
                      
                      @if (isCarelonCoordinationActionSelected(action) && action === 'Other') {
                        <div class="mt-2 ml-6">
                          <div class="field">
                            <label for="carelonCoordinationOtherDetails" class="block mb-2 text-sm field-required">Other - Details:
                            </label>
                          </div>
                          <textarea
                            pTextarea
                            id="carelonCoordinationOtherDetails"
                            rows="3"
                            class="w-full"
                            formControlName="carelonCoordinationOtherDetails"
                            maxlength="5000"
                          ></textarea>
                          <span class="block text-right">{{ appealsForm?.get('carelonCoordinationOtherDetails')?.value ? appealsForm?.get('carelonCoordinationOtherDetails')?.value.length : 0 }} / 5000</span>
                        </div>
                      }
                    </div>
                  }
                </div>
                <p class="info-message">
                  <i class="pi pi-info-circle"></i>
                  Notification/escalation only
                </p>
              </div>
            </div>

          <!-- Notes -->
          <div class="col-span-12">
            <div class="field">
              <label for="carelonCoordinationNotes">
                Notes:
              </label>
              <textarea
                pTextarea
                id="carelonCoordinationNotes"
                formControlName="carelonCoordinationNotes"
                rows="4"
                class="w-full"
                maxlength="5000"
              ></textarea>
              <span class="block text-right">{{ appealsForm?.get('carelonCoordinationNotes')?.value ? appealsForm?.get('carelonCoordinationNotes')?.value.length : 0 }} / 5000</span>
              </div>
            </div>

          <!-- Chronology of Events -->
          <div class="col-span-12">
            <div>
              <div class="field">
                <label>Outreach/RFI request(s) to facility:</label>
              </div>
              <div class="flex flex-col gap-3 mt-2">
                <p-button
                  label="Add Date"
                  icon="pi pi-plus"
                  (onClick)="addOutreachRfiDate()"
                  [outlined]="true"
                  size="small"
                  styleClass="w-fit"
                ></p-button>
                
                  @for (control of outreachRfiDatesArray?.controls; track control; let i = $index) {
                  <div class="flex gap-2 items-center">
                    <label class="text-sm field-required" >Date:</label>
                    <p-datepicker
                      [formControl]="control"
                      [showIcon]="true"
                      [showButtonBar]="true"
                      [readonlyInput]="true"
                      styleClass="w-35"
                    ></p-datepicker>
                    <p-button
                      icon="pi pi-times"
                      severity="secondary"
                      [text]="true"
                      (onClick)="removeOutreachRfiDate(i)"
                    ></p-button>
                  </div>
                }
                </div>
              </div>
            </div>

          <!-- Denial to Evidence Crosswalk -->
          <div class="col-span-12">
            <div class="field">
              <label for="transitionOfCareCoordination" class="field-required">Transition of Care Coordination:
              </label>
              <textarea
                pTextarea
                id="transitionOfCareCoordination"
                formControlName="transitionOfCareCoordination"
                rows="4"
                class="w-full"
                maxlength="5000"
              ></textarea>
              <span class="block text-right">{{ appealsForm?.get('transitionOfCareCoordination')?.value ? appealsForm?.get('transitionOfCareCoordination')?.value.length : 0 }} / 5000</span>
              </div>
            </div>

          <!-- Generate Button -->
          <div class="col-span-12">
            <div class="mt-6 flex justify-end">
              <p-button
                label="Generate Appeal Packet"
                icon="pi pi-file-pdf"
                (onClick)="generateAppealsPacket()"
                [disabled]="!isFormValid || isGenerating"
                [loading]="isGenerating"
                severity="primary"
              ></p-button>
            </div>
          </div>
        }
      </div>
    </form>
  </p-panel>
</div>

<!-- Auth/Appeal Details Modal -->
<p-dialog
  [(visible)]="showAuthAppealDetails"
  [header]="'Auth/Appeal Details'"
  [modal]="false"
  [style]="{width: '30vw'}"
  [closable]="true"
  [appendTo]="'body'"
  [draggable]="true"
  [resizable]="true"
>
  @if (authAppealDetails) {
    <div class="space-y-4">
      <p class="appeals-packet-info mb-4">
        The following information will be included in the generated appeals packet.
      </p>
      
      <!-- HP Appeal Layout -->
      @if (!isQIOAppeal) {
        <div class="grid grid-cols-2 gap-x-8 gap-y-3">
          <!-- Row 1 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Member Name:</p>
            <p class="font-normal">{{ authAppealDetails?.memberData?.firstName + ' ' + authAppealDetails?.memberData?.lastName }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Authorization Type:</p>
            <p class="font-normal">{{ "PAC-IM" }}</p>
          </div>
          
          <!-- Row 2 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Member ID:</p>
            <p class="font-normal">{{ authAppealDetails?.memberData?.displayMemberId }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Setting:</p>
            <p class="font-normal">{{ authAppealDetails?.facilityType?.description }}</p>
          </div>
          
          <!-- Row 3 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">MBI:</p>
            <p class="font-normal">{{ authAppealDetails?.mbi || '—' }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Facility Name:</p>
            <p class="font-normal">{{ authAppealDetails?.facilityName || '—'}}</p>
          </div>
          
          <!-- Row 4 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Date of Birth:</p>
            <p class="font-normal">{{ authAppealDetails?.memberData?.dateOfBirth }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">A&G Reference Number:</p>
            <p class="font-normal">{{ authAppealDetails?.agReferenceNumber || '—'}}</p>
          </div>
          
          <!-- Row 5 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Health Plan:</p>
            <p class="font-normal">{{ tenantName }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Admission Date:</p>
            <p class="font-normal">{{ formattedAdmissionDate }}</p>
          </div>
          
          <!-- Row 6 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Line of Business:</p>
            <p class="font-normal">{{ lineOfBusiness }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Appeal Filed Date:</p>
            <p class="font-normal">{{ authAppealDetails?.appealFiledDate ? (authAppealDetails?.appealFiledDate | date:'MM/dd/yyyy') : '—'}}</p>
          </div>
          
          <!-- Row 7 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Authorization Number:</p>
            <p class="font-normal">{{ authorizationNumber }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Health Plan Case/Appeal Number:</p>
            <p class="font-normal">{{ authAppealDetails?.caseAppealNumber || '—'}}</p>
          </div>
        </div>
      }
      
      <!-- QIO Appeal Layout -->
      @if (isQIOAppeal) {
        <div class="grid grid-cols-2 gap-x-8 gap-y-3">
          <!-- Row 1 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Member Name:</p>
            <p class="font-normal">{{ authAppealDetails?.memberData?.firstName + ' ' + authAppealDetails?.memberData?.lastName }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Facility Name:</p>
            <p class="font-normal">{{ authAppealDetails?.facilityName || '—'}}</p>
          </div>
          
          <!-- Row 2 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Member ID:</p>
            <p class="font-normal">{{ authAppealDetails?.memberData?.displayMemberId }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">A&G Reference Number:</p>
            <p class="font-normal">{{ authAppealDetails?.agReferenceNumber || '—'}}</p>
          </div>
          
          <!-- Row 3 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">MBI:</p>
            <p class="font-normal">{{ authAppealDetails?.mbi || '—' }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Admission Date:</p>
            <p class="font-normal">{{ formattedAdmissionDate }}</p>
          </div>
          
          <!-- Row 4 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Date of Birth:</p>
            <p class="font-normal">{{ authAppealDetails?.memberData?.dateOfBirth }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">QIO Case/Appeal Number:</p>
            <p class="font-normal">{{ authAppealDetails?.caseAppealNumber || '—'}}</p>
          </div>
          
          <!-- Row 5 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Health Plan:</p>
            <p class="font-normal">{{ tenantName }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">Appeal Filed Date:</p>
            <p class="font-normal">{{ authAppealDetails?.appealFiledDate ? (authAppealDetails?.appealFiledDate | date:'MM/dd/yyyy') : '—'}}</p>
          </div>
          
          <!-- Row 6 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Line of Business:</p>
            <p class="font-normal">{{ lineOfBusiness }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">QIO Notification Received Date:</p>
            <p class="font-normal">{{ authAppealDetails?.qioNotificationReceivedDate ? (authAppealDetails?.qioNotificationReceivedDate | date:'MM/dd/yyyy'):'—'}}</p>
          </div>
          
          <!-- Row 7 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Authorization Number:</p>
            <p class="font-normal">{{ authorizationNumber }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">NOMNC Delivered to Service Provider Date:</p>
            <p class="font-normal">{{ authAppealDetails?.nomncDeliveredToServiceProviderDate ? (authAppealDetails?.nomncDeliveredToServiceProviderDate | date:'MM/dd/yyyy'):'—'}}</p>
          </div>
          
          <!-- Row 8 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Authorization Type:</p>
            <p class="font-normal">{{ "PAC-IM" }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600 mb-1">DENC Delivered Date:</p>
            <p class="font-normal">{{ authAppealDetails?.dencDeliveredDate ? (authAppealDetails?.dencDeliveredDate | date:'MM/dd/yyyy'):'—'}}</p>
          </div>
          
          <!-- Row 9 -->
          <div>
            <p class="text-sm text-gray-600 mb-1">Setting:</p>
            <p class="font-normal">{{ authAppealDetails?.facilityType?.description || '—'}}</p>
          </div>
        </div>
      }
    </div>
  }
  
  <ng-template pTemplate="footer">
    <p-button
      label="Close"
      (onClick)="closeAuthAppealDetailsModal()"
      [outlined]="true"
    ></p-button>
  </ng-template>
</p-dialog>
